import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import useHost from "containers/host/useHooks";
import { useDebounce } from "hooks/useDebounce";
import EventCard from "components/cards/event-card";
import { EventDTO } from "utils/helpers/models/shared/event.dto";
import { EventsFilterDTO } from "utils/helpers/models/host-dtos/events-filter.dto";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import noWishlistFound from "assets/images/gifs/wishlist-not-found.gif";

const Wishlist = () => {
  const [filters, setFilters] = useState<Partial<EventsFilterDTO>>({
    status: EVENT_STATUS.WISHLIST,
    searchTitle: "",
    page: 1,
    totalPages: 1,
    size: 10,
  });
  const debounceSearch = useDebounce(filters.searchTitle, 800);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  const { getEvents } = useHost();
  const [events, setEvents] = useState<EventDTO[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (params?.id) {
      getAllEvents([], filters);
    }
  }, [debounceSearch]);

  useEffect(() => {
    if (isInitialLoad && !isLoading) {
      setIsInitialLoad(false);
    }
  }, [isLoading, events]);

  const getAllEvents = (
    previousEvents: EventDTO[],
    filters: Partial<EventsFilterDTO>
  ) => {
    const queryParams = {
      childId: params?.id,
      ...filters,
      page: filters.page - 1,
    };
    getEvents(setEvents, queryParams, previousEvents, setFilters);
    setFilters({ ...filters });
  };

  return (
    <div className=" min-h-[50vh] pb-6">
      <div className="flex flex-wrap items-center justify-end gap-5">
        {/* Dropdown for Event Selection */}
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FiSearch className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="searchTitle"
            value={filters.searchTitle}
            onChange={(e) =>
              setFilters({ ...filters, searchTitle: e.target.value })
            }
            placeholder="Search Events"
            className="w-full pl-10 pr-4 py-2 h-[51px] rounded-lg border border-inputsBorderColor outline-none"
          />
        </div>
      </div>

      {/* Experiences Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
        {events.map((event, index) => (
          <EventCard event={event} key={index} showBookmark={false} />
        ))}
      </div>
      {filters.totalPages > filters.page && (
        <div className="text-center mt-10">
          <button
            className="px-6 py-2 bg-fade text-primaryBlueText rounded-full"
            onClick={() =>
              getAllEvents(events, { ...filters, page: filters.page + 1 })
            }
          >
            See More
          </button>
        </div>
      )}
      <div className="mt-10">
        <CustomMessageDisplay
          show={!isLoading && !isInitialLoad && !events.length}
          title="No Wishlist Items"
          slogan="Add experiences to your wishlist to see them here!"
          image={noWishlistFound}
          imageAlt="No wishlist items found"
          className="py-16"
          imageClassName="w-[150px] h-[120px]"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      </div>
    </div>
  );
};

export default Wishlist;
